import React from 'react';

const CountUpDown = ({
  currentValue,
  maxValue,
  minValue = 1,
  onIncrement,
  onDecrement,
  disabled = false,
  className = '',
  valueClassName = '',
  buttonClassName = '',
}) => {
  const isIncrementDisabled = disabled || currentValue >= maxValue;
  const isDecrementDisabled = disabled || currentValue <= minValue;

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <span className={`px-3 text-center ${valueClassName}`}>
        {currentValue}
      </span>
      {!disabled && (
        <div
          className={`w-4 h-4 py-1 flex rounded items-center justify-between flex-col bg-border-light-secondary ${buttonClassName}`}>
          <svg
            onClick={onIncrement}
            disabled={isIncrementDisabled}
            className={`${
              isIncrementDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
            }`}
            xmlns="http://www.w3.org/2000/svg"
            width="9"
            height="6"
            viewBox="0 0 9 6"
            fill="none">
            <path
              d="M1.5 5L4.5 2L7.5 5"
              stroke="#2B303B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <svg
            onClick={onDecrement}
            disabled={isDecrementDisabled}
            className={`${
              isDecrementDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
            }`}
            xmlns="http://www.w3.org/2000/svg"
            width="9"
            height="6"
            viewBox="0 0 9 6"
            fill="none">
            <path
              d="M1.5 1L4.5 4L7.5 1"
              stroke="#2B303B"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      )}
    </div>
  );
};

export default CountUpDown;
